import React from "react";
import { Link } from "react-router-dom";
import useCartStore from "../store/shoppingCardStore";
import { ShoppingCart, Plus, Minus, Battery } from "lucide-react";
import styles from "../styles/Cards.module.css";
import Product1 from "../images/products/battrey-varian.jpg";
import p11 from "../images/products/pu1.1.jpg";
import p12 from "../images/products/pu1.2.jpg";
import p13 from "../images/products/pu1.3.jpg";
import p14 from "../images/products/pu1.4.jpg";
import p21 from "../images/products/pu2.1.jpg";
import p22 from "../images/products/pu2.2.jpg";
import p23 from "../images/products/pu2.3.jpg";
import p24 from "../images/products/pu2.4.jpg";
import p31 from "../images/products/pu3.1.jpg";
import p32 from "../images/products/pu3.2.jpg";
import p33 from "../images/products/pu3.3.jpg";
import p34 from "../images/products/pu3.4.jpg";
import p41 from "../images/products/pu4.1.jpg";
import p42 from "../images/products/pu4.2.jpg";
import p43 from "../images/products/pu4.3.jpg";
import p44 from "../images/products/pu4.4.jpg";
import { slugify } from "../utils/utils"; // Import slugify

const products = [
  {
    name: "باتری یو پی اس صبا 12 ولت 18 آمپر (Saba UPS 12V-18Ah)",
    slug: "battery-12v-18ah-saba-sealed-lead-acid-ups",
    image: [p11, p12, p13, p14],
    info: `
<h2>خرید و قیمت باتری 12 ولت 18 آمپر صبا باتری</h2>
<p>باتری یو پی اس صبا باتری منبعی است که با تبدیل انرژی شیمیایی به انرژی الکتریکی، بین دو نقطه اختلاف پتانسیل الکتریکی ایجاد کرده و برق DC تولید می‌کند. این مدل با ولتاژ 12 ولت و ظرفیت 18 آمپر ساعت، یکی از پرفروش‌ترین محصولات در بازار برق و الکترونیک می‌باشد.</p>

<h3>کاربردهای باتری 12V-18Ah صبا باتری</h3>
<p>این باتری در تجهیزات متنوعی قابل استفاده است از جمله:</p>

<ul>
  <li>سیستم‌های یو پی اس</li>
  <li>لیفتراک و خودروهای برقی</li>
  <li>موتورهای برقی</li>
  <li>تابلوهای فرمان اساسنور</li>
  <li>ماشین‌های چمن‌زنی و گلف</li>
  <li>ویلچرهای برقی</li>
  <li>و سایر تجهیزات الکترونیکی</li>
</ul>

<h3>ویژگی‌های کلیدی</h3>
<p>باتری سیلد لید اسید (خشک) صبا باتری با مشخصات زیر ارائه می‌شود:</p>
<ul>
  <li>نیاز به نگهداری و افزودن آب مقطر ندارد</li>
  <li>طراحی مقاوم و پایدار</li>
  <li>عملکرد قابل اطمینان در شرایط مختلف</li>
  <li>طول عمر مناسب</li>
</ul>

<p>این محصول با ابعاد 181×78×165 میلی‌متر و وزن 6.5 کیلوگرم، گزینه‌ای ایده‌آل برای مصارف صنعتی و تجاری است. برای خرید باتری 12 ولت 18 آمپر اصل با گارانتی معتبر، می‌توانید به باتری۱۰۰ مراجعه کنید.</p>`,
    price: 2500000,
    infos: `
<ul>
<li><strong>نوع:</strong> سیلد لید اسید (خشک)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 18 آمپر ساعت</li>
<li><strong>مقاومت داخلی:</strong> 20 میلی اهم</li>
<li><strong>ابعاد:</strong> 181×78×165 میلی‌متر</li>
<li><strong>وزن:</strong> 6.5 کیلوگرم</li>
<li><strong>تکنولوژی:</strong> باتری سیلد اسید یو پی اس</li>
<li><strong>کشور تولید کننده:</strong> ایران</li>
<li><strong>ولتاژ شارژ شناور:</strong> 13.38-13.68 ولت</li>
</ul>`,
    id: 1,
    meta: {
      title: "خرید باتری 12 ولت 18 آمپر صبا باتری | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری 12 ولت 18 آمپر صبا باتری مدل سیلد اسید UPS با کیفیت بالا و کاربردهای متنوع. قیمت روز و مشخصات فنی کامل.",
      keywords:
        "باتری 12 ولت 18 آمپر, باتری یو پی اس, باتری سیلد اسید, صبا باتری",
    },
  },
  {
    name: "باتری یو پی اس صبا 12 ولت 28 آمپر(Saba UPS 12V-28Ah)",
    slug: "battery-12v-28ah-saba-ups",
    image: [p21, p22, p23, p24],
    info: `
<h2>خرید و قیمت باتری یو پی اس صبا 28 آمپر 12 ولت</h2>
<p>باتری یو پی اس صبا 28 آمپر 12 ولت با طراحی بدون نیاز به تعمیر و نگهداری، منبعی قابل اعتماد برای تأمین جریان الکتریکی در محیط‌های حساس می‌باشد. این محصول با مقاومت و پوشش ویژه، گزینه‌ای ایده‌آل برای مصارف صنعتی و تجاری است.</p>

<h3>کاربردهای باتری 28 آمپر صبا</h3>
<p>این باتری در سیستم‌های متنوعی قابل استفاده است از جمله:</p>

<ul>
  <li>سیستم‌های یو پی اس و سرورها</li>
  <li>چرخ‌دستی‌های گلف و ماشین‌آلات گلف</li>
  <li>ماشین‌های چمن‌زنی برقی</li>
  <li>خودروهای برقی سواری کودکان</li>
  <li>سیستم‌های روشنایی قابل حمل</li>
  <li>اسکوترهای برقی و وسایل نقلیه الکتریکی</li>
  <li>لیفتراک‌های برقی</li>
</ul>

<h3>مزایای کلیدی</h3>
<ul>
  <li>طراحی سیلد اسید (بدون نیاز به نگهداری)</li>
  <li>مقاومت بالا در برابر شرایط سخت کاری</li>
  <li>عملکرد پایدار و قابل اطمینان</li>
  <li>طول عمر بالا و دوام قابل توجه</li>
  <li>گارانتی 12 ماهه تعویض</li>
</ul>

<p>باتری یو پی اس صبا 28 آمپر با استفاده از جدیدترین تکنولوژی و مواد اولیه مرغوب تولید شده است. برای خرید این محصول با کیفیت و قیمت مناسب می‌توانید به باتری۱۰۰ مراجعه کنید.</p>`,
    price: 3900000,
    infos: `
<ul>
<li><strong>نوع:</strong> سیلد اسید (خشک)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 28 آمپر ساعت</li>
<li><strong>ابعاد:</strong> استاندارد یو پی اس</li>
<li><strong>وزن:</strong> متناسب با ظرفیت</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت تعویض</li>
<li><strong>تکنولوژی:</strong> سیلد لید اسید</li>
<li><strong>کشور تولید کننده:</strong> ایران</li>
</ul>
`,
    id: 2,
    meta: {
      title:
        "خرید باتری یو پی اس صبا 28 آمپر 12 ولت | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری یو پی اس صبا 28 آمپر 12 ولت با کیفیت بالا و گارانتی 12 ماهه، مناسب برای سیستم‌های حساس و صنعتی. قیمت روز و مشخصات فنی.",
      keywords:
        "باتری یو پی اس 28 آمپر, باتری 12 ولت صبا, باتری سیلد اسید, خرید باتری UPS",
    },
  },
  {
    name: "باتری یو پی اس صبا 12 ولت 42 آمپر(Saba UPS 12V-42Ah)",
    slug: "battery-42ah-saba-ups",
    image: [p31, p32, p33, p34],
    info: `
<h2>خرید و قیمت باتری 42 آمپر یو پی اس صبا</h2>
<p>باتری 42 آمپر یو پی اس صبا به عنوان منبع پشتیبان اضطراری برق در سیستم‌های حیاتی کاربرد دارد. این محصول با کیفیت بالا و طراحی بهینه، گزینه‌ای ایده‌آل برای محافظت از تجهیزات الکترونیکی در برابر اختلالات برق می‌باشد.</p>

<h3>کاربردهای اصلی</h3>
<p>این باتری در صنایع و تجهیزات مختلفی استفاده می‌شود:</p>

<ul>
  <li>تجهیزات پزشکی حیاتی (مانیتورها، دستگاه‌های تنفس مصنوعی)</li>
  <li>دستگاه‌های تصویربرداری پزشکی (MRI، CT-Scan)</li>
  <li>سیستم‌های امنیتی و حفاظتی (دوربین‌های مداربسته، اعلام حریق)</li>
  <li>سیستم‌های صنعتی و تولیدی</li>
  <li>مراکز داده و سرورها</li>
</ul>

<h3>ویژگی‌های فنی برجسته</h3>
<p>مهم‌ترین مزایای این محصول شامل:</p>
<ul>
  <li>طراحی سرب-اسید مهر و موم شده (VRLA) بدون نیاز به نگهداری</li>
  <li>عملکرد عالی در بازیابی تخلیه عمیق</li>
  <li>خاصیت خود تخلیه پایین</li>
  <li>انعطاف پذیری در نصب با قابلیت قرارگیری در موقعیت‌های مختلف</li>
  <li>بهینه‌سازی شده برای استفاده با سیستم‌های یو پی اس</li>
</ul>

<p>این باتری با ابعاد 197×166×169 میلی‌متر و وزن 13.1 کیلوگرم، یکی از پرکاربردترین محصولات در صنایع مختلف محسوب می‌شود. برای خرید باتری 42 آمپر اصل با گارانتی معتبر صبا باتری، می‌توانید با کارشناسان ما تماس بگیرید.</p>`,
    price: 6900000,
    infos: `
<ul>
<li><strong>نوع:</strong> سرب-اسید مهر و موم شده (VRLA)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 42 آمپر ساعت</li>
<li><strong>ابعاد:</strong> 197×166×169 میلی‌متر</li>
<li><strong>وزن:</strong> 13.1 کیلوگرم</li>
<li><strong>کاربرد اصلی:</strong> سیستم‌های یو پی اس</li>
<li><strong>تکنولوژی:</strong> VRLL (شیر تنظیم)</li>
<li><strong>گارانتی:</strong> 18 ماهه</li>
</ul>
`,
    id: 3,
    meta: {
      title:
        "خرید باتری 42 آمپر یو پی اس صبا | قیمت با گارانتی 18 ماهه | باتری۱۰۰",
      description:
        "باتری 42 آمپر یو پی اس صبا با گارانتی 18 ماهه، مناسب برای تجهیزات پزشکی، سیستم‌های امنیتی و صنعتی. مشخصات فنی کامل و قیمت روز.",
      keywords:
        "باتری 42 آمپر, باتری یو پی اس, صبا باتری, باتری سیلد اسید, باتری 12 ولت",
    },
  },
  {
    name: "باتری یو پی اس صبا 12 ولت 65 آمپر(Saba UPS 12V-65Ah)",
    slug: "battery-12v-65ah-saba-ups",
    image: [p41, p42, p43, p44],
    info: `
<h2>خرید و قیمت باتری یو پی اس 12 ولت 65 آمپر صبا باتری</h2>
<p>باتری یو پی اس 12 ولت 65 آمپر صبا باتری با تکنولوژی تولید به روز از نوع سیلد اسید، مناسب‌ترین گزینه برای اتصال به دستگاه‌های UPS می‌باشد. این محصول یک منبع انرژی جایگزین است که تضمین می‌کند در صورت اختلال در منبع انرژی شهری، انرژی مورد نیاز تجهیزات متصل برای مدت معینی تأمین شود.</p>

<h3>کاربردهای باتری 12V-65Ah صبا باتری</h3>
<p>این باتری در مکان‌های حیاتی و حساس استفاده می‌شود:</p>

<ul>
  <li>ادارات و شرکت‌ها (تجهیزات اداری و کامپیوتری)</li>
  <li>مراکز درمانی و بیمارستان‌ها (دستگاه‌های پزشکی)</li>
  <li>کارگاه‌ها و کارخانه‌ها (ماشین‌آلات صنعتی)</li>
  <li>منازل (سیستم‌های امنیتی و روشنایی اضطراری)</li>
  <li>مراکز بانکی و مالی</li>
</ul>

<h3>مزایای کلیدی</h3>
<p>باتری VRLA صبا باتری با مشخصات زیر ارائه می‌شود:</p>
<ul>
  <li>طراحی سیلد اسید مهر و موم شده (SLA) بدون نیاز به نگهداری)</li>
  <li>عملکرد قابل اطمینان در شرایط بحرانی</li>
  <li>طول عمر مناسب با نگهداری صحیح</li>
  <li>حفاظت از تجهیزات در برابر نوسانات برق</li>
  <li>سازگاری با انواع سیستم‌های یو پی اس</li>
</ul>

<h3>نکات نگهداری و افزایش عمر</h3>
<ul>
  <li>نگهداری در دمای مناسب (بین 20-25 درجه سانتیگراد)</li>
  <li>پرهیز از شارژ و دشارژ عمیق مکرر</li>
  <li>بررسی دوره‌ای وضعیت باتری</li>
  <li>عدم استفاده همزمان باتری‌های قدیمی و جدید در یک سیستم</li>
</ul>

<p>این محصول با گارانتی معتبر و خدمات پس از فروش قابل اطمینان ارائه می‌شود. برای خرید باتری 65 آمپر اصل با تاریخ تولید جدید می‌توانید به نمایندگی‌های معتبر مراجعه کنید.</p>`,
    price: 10200000,
    infos: `
<ul>
<li><strong>نوع:</strong> سیلد اسید (VRLA)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 65 آمپر ساعت</li>
<li><strong>تکنولوژی:</strong> سرب-اسید مهر و موم شده</li>
<li><strong>کاربرد اصلی:</strong> سیستم‌های یو پی اس</li>
<li><strong>طول عمر مفید:</strong> 3-5 سال (با نگهداری مناسب)</li>
<li><strong>کشور تولید کننده:</strong> ایران</li>
<li><strong>گارانتی:</strong> دارد (مدت بر اساس سیاست فروشنده)</li>
</ul>
`,
    id: 4,
    meta: {
      title:
        "خرید باتری یو پی اس 12 ولت 65 آمپر صبا | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری یو پی اس 12 ولت 65 آمپر صبا باتری با تکنولوژی VRLA - مناسب برای سیستم‌های UPS اداری، صنعتی و پزشکی - قیمت روز و مشخصات فنی",
      keywords:
        "باتری 65 آمپر, باتری یو پی اس صبا, قیمت باتری 12 ولت, باتری سیلد اسید, باتری UPS",
    },
  },
];

const UpsCards = () => {
  const { items, itemscount, addItem, removeItem } = useCartStore();
  const nameitem = items.map((item) => item.name);

  // تابع برای بررسی موجود بودن محصول
  const isProductAvailable = (productName) => {
    return !productName.includes("(ناموجود)");
  };

  return (
    <div className={styles.cardsContainer}>
      <div className={styles.header}>
        <Battery className={styles.headerIcon} size={28} />
        <h2> محصولات باتری یو پی اس (ups)</h2>
        <p>با کیفیت ترین باتری ها با گارانتی معتبر</p>
        <Link
          to={{
            pathname: "/محصولات/",
            state: { defaultFilter: "car" },
          }}
          className={styles.viewAllBtn}
        >
          نمایش تمام محصولات باتری یو پی اس
        </Link>
      </div>

      <div className={styles.productsGrid}>
        {products.map((product) => (
          <div key={product.id} className={styles.productCard}>
            <Link
              to={`/product/${slugify(product.name)}`}
              className={styles.productImageLink}
            >
              <img
                src={product.image[0]}
                alt={product.name}
                className={styles.productImage}
                loading="lazy"
              />
              <div className={styles.productOverlay}>
                <span>مشاهده جزئیات</span>
              </div>
            </Link>

            <div className={styles.productInfo}>
              <h3 className={styles.productTitle}>
                {product.name}
                <span className={styles.productCategory}>باتری - UPS</span>
              </h3>

              <p className={styles.productPrice}>
                <span className={styles.priceLabel}>قیمت: </span>
                {product.price.toLocaleString()} تومان
              </p>

              {/* تغییر در این بخش */}
              {!isProductAvailable(product.name) ? (
                <div className={styles.outOfStock}>ناموجود</div>
              ) : nameitem.includes(product.name) ? (
                <div className={styles.quantityControl}>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      removeItem(product.id);
                    }}
                    className={styles.quantityBtn}
                    aria-label="کاهش تعداد"
                  >
                    <Minus size={16} />
                  </button>
                  <span className={styles.quantityCount}>
                    {itemscount[product.id] || 0}
                  </span>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      addItem(product);
                    }}
                    className={styles.quantityBtn}
                    aria-label="افزایش تعداد"
                  >
                    <Plus size={16} />
                  </button>
                </div>
              ) : (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    addItem(product);
                  }}
                  className={styles.addToCartBtn}
                >
                  <ShoppingCart size={18} />
                  افزودن به سبد خرید
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpsCards;
